import { forwardRef, useState } from 'react';

export const PasswordInput = forwardRef(function PasswordInput(
  { id, name, value, onChange, error = false, className = '', ...rest },
  ref,
) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="password-wrapper">
      <input
        ref={ref}
        id={id}
        name={name}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        aria-invalid={error ? 'true' : undefined}
        className={`form-field-input ${className}`.trim()}
        {...rest}
      />
      <button
        type="button"
        className="password-toggle"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? 'Hide' : 'Show'}
      </button>
    </div>
  );
});
